import { render } from "./FlowCards.vue?vue&type=template&id=79311b51"
import script from "./FlowCards.vue?vue&type=script&lang=js"
export * from "./FlowCards.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__